export default __webpack_public_path__ + "static/media/boxtype1.c86265f7.JPG";